import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './.providers/auth.service';
import { MainService } from './.providers/main.service';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'app';
	public isLoggedIn: Boolean;
	private user_displayName: String;
	private user_email: String;
	constructor(public authService: AuthService, public mainService: MainService, private router: Router) {
		this.mainService.registerUser();
		this.isLoggedIn = false;
		this.user_displayName = '';
		this.user_email = '';
		this.router.navigate(['login']);
		this.authService.af.authState.subscribe(auth => {
			if (auth == null) {
				console.log('Logged out');
				this.isLoggedIn = false;
				this.user_displayName = '';
				this.user_email = '';
				this.router.navigate(['login']);
			} else {
				localStorage.setItem('user', JSON.stringify(auth));
				this.isLoggedIn = true;
				this.user_displayName = auth.displayName;
				this.user_email = auth.email;
				console.log('Logged in');
				console.log(auth);
				console.log('uid-' + auth.uid);
				this.router.navigate(['']);
			}
		});
	}

	logout() {
		this.authService.logout();
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/app.component.ts